import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-查看",
  "use": "icon-查看-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-查看\">\n<path d=\"M17.5939 84.6662C16.1463 82.8188 14.9676 81.2282 14.0842 80C14.9676 78.7719 16.1463 77.1813 17.5939 75.3338C21.1311 70.8193 26.2409 64.8122 32.5353 58.8219C45.3156 46.659 62.1046 35.4 80 35.4C97.8954 35.4 114.684 46.659 127.465 58.8219C133.759 64.8122 138.869 70.8193 142.406 75.3338C143.854 77.1813 145.032 78.7719 145.916 80C145.032 81.2282 143.854 82.8188 142.406 84.6662C138.869 89.1807 133.759 95.1878 127.465 101.178C114.684 113.341 97.8954 124.6 80 124.6C62.1046 124.6 45.3156 113.341 32.5353 101.178C26.2409 95.1878 21.1311 89.1807 17.5939 84.6662Z\" stroke=\"#5691F2\" stroke-width=\"10\" />\n<circle cx=\"80\" cy=\"80\" r=\"19\" stroke=\"#5691F2\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/查看.svg
// module id = rBXJ
// module chunks = 26